// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__t7Kra","title":"style_title__GD+Qm","text":"style_text__QoHwI","navigate":"style_navigate__RZX7i"};